(function ($) {

  Drupal.behaviors.elc_common = {
    attach: function (context, settings) {
      $('.ajax-popover', context).colorbox({ maxWidth: '100%', maxHeight: '100%', href: function() { return this.href + ' #main'; } });
      $('.slide-toggle', context).click(function () {
        $(this).siblings('.view-filters').slideToggle('slow');
      });
      // Hide Nid Export's title 'Refine Results' on VBO confirmation page.
      $('form#views-form-nid-export-page-list').parent().siblings('.slide-toggle').hide();
    }
  };

})(jQuery);

